import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, timer } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { ApiEndPoint } from "src/configurations/constants";
import { configuration } from "src/configurations/configuration";

@Injectable({
  providedIn: "root",
})
export class CompanyInfoService {
  httpOptions;
  httpBoday = "";
  constructor(private http: HttpClient) {}

  getCompanyInfo() {
    const token = localStorage.getItem("token");
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
        "language-iso": "en",
      }),
    };

    return this.http.get<any>(ApiEndPoint.Company.details, this.httpOptions).pipe(
      tap(
        () => { },
        () => { }
      )
    );
  }

  checkCompanyName(name: string): Observable<any> {
    const token = localStorage.getItem("token");
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: token,
        "language-iso": "en",
      }),
    };

    return this.http.post<any>(ApiEndPoint.Career.page + "/duplicated", { name: name },  this.httpOptions);
  }

  checkIfCareerDuplicated(link: string): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    return this.http.post<any>(ApiEndPoint.Career.page + '/duplicated', 
                                  {name: `${link}.${configuration.career}`},
                                  httpOptions);
  }

  isCareerUrlDuplicated(url: string): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(500).pipe(
      switchMap(() => {
        return this.http.post<any>(ApiEndPoint.Career.page + '/duplicated', 
                                  {name: url},
                                  httpOptions); 
      })
    );
  }

  isSMSEnabled(): Observable<any> {
    const token = localStorage.getItem("token");

    const httpOptions = {
      headers:  new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token,
        'language-iso': 'en'
      })
    };

    return this.http.get<any>(ApiEndPoint.Company.smsEnabled, httpOptions);
  }
}
